import { render } from "./group-index.vue?vue&type=template&id=1cea6e28&scoped=true&ts=true"
import script from "./group-index.vue?vue&type=script&lang=ts"
export * from "./group-index.vue?vue&type=script&lang=ts"

import "./group-index.vue?vue&type=style&index=0&id=1cea6e28&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cea6e28"]])

export default __exports__